/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Style_Preset_None_SelectedInputs */

const en_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No preset selected`)
};

const fr_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun prereglage selectionne`)
};

const de_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Voreinstellung ausgewählt`)
};

const it_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun preset selezionato`)
};

const ru_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительно заданные параметры не выбраны`)
};

const es_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se ha seleccionado ningún ajuste preestablecido`)
};

const zh_cn2_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未选择预设值`)
};

const ja_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットが選択されていません`)
};

const hi_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई पूर्व निर्धारित सेटिंग चयनित नहीं है`)
};

const pt_pt2_image_export_style_preset_none_selected = /** @type {(inputs: Image_Export_Style_Preset_None_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma predefinição selecionada`)
};

/**
* | output |
* | --- |
* | "No preset selected" |
*
* @param {Image_Export_Style_Preset_None_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_style_preset_none_selected = /** @type {((inputs?: Image_Export_Style_Preset_None_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Style_Preset_None_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_style_preset_none_selected(inputs)
	if (locale === "de") return de_image_export_style_preset_none_selected(inputs)
	if (locale === "it") return it_image_export_style_preset_none_selected(inputs)
	if (locale === "ru") return ru_image_export_style_preset_none_selected(inputs)
	if (locale === "es") return es_image_export_style_preset_none_selected(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_style_preset_none_selected(inputs)
	if (locale === "ja") return ja_image_export_style_preset_none_selected(inputs)
	if (locale === "hi") return hi_image_export_style_preset_none_selected(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_style_preset_none_selected(inputs)
	return en_image_export_style_preset_none_selected(inputs)
});